import React from "react"

import { Card } from 'primereact/card'
import { Message } from 'primereact/message'

import FieldPassword from './FieldPassword'

const ChangePasswordSection = ({ validationRules, isAdmin }) => {
  return (
    <div id="changePasswordSection">
    <Card title="Change Password">
      <div className="p-grid">
        <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="" text="Password must be at least 8 characters, contain 1 digit, contain 1 uppercase letter and contain 1 lowercase letter."></Message>
        </div>
        {isAdmin === false && <div className="p-col-12">
          <FieldPassword inputStyle={{ width: 260 }} field={"CurrentPassword"} label={"Current Password"} validationRules={validationRules} />
        </div>}
        <div className="p-col-12">
          <FieldPassword inputStyle={{ width: 260 }} field={"NewPassword"} label={"Password"} validationRules={validationRules} />
        </div>
        <div className="p-col-12">
          <FieldPassword inputStyle={{ width: 260 }} field={"ConfirmPassword"} label={"Confirm Password"} validationRules={validationRules} />
        </div>
      </div>
    </Card>
    </div>
  )
}

export default ChangePasswordSection


// WEBPACK FOOTER //
// ./src/components/common/ChangePasswordSection.js